
  <div class="center" [ngClass]="{'menu-background': fromPage !== 'header-desktop', 'header-background': fromPage === 'header-desktop'}">
    <ion-toggle mode="md" [checked]="isDarkTheme" (ionChange)="themeService.toggleAppTheme($event)">
      <ion-text>{{ lightThemeName | translate }}</ion-text></ion-toggle> 
    <ion-text class="ion-padding">{{ darkThemeName | translate }}</ion-text>
  </div>

